import _ from "lodash";

export enum Role {
    Administrator = 'Botstation-administrator',
    Finance = 'Botstation-finance',
    Transcription = 'Botstation-transcription',
    Statistic = 'Botstation-statistic',
    Builder = 'Botstation-builder',
    BuilderVisitor = 'Botstation-builder-visitor'
}

export const isAuthorized = (userRole: string | string[], requiredRole: string) => {
    if(_.includes(userRole, Role.Administrator) || _.includes(userRole, requiredRole)){
        return true;
    } else {
        return false;
    }
}